var _g, _circle, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogouticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 217,
    viewBox: "0 0 217 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_851_3241)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 108.199,
    cy: 108.2,
    r: 54.5,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108.199,
    cy: 108.2,
    r: 43.5,
    fill: "#E1F7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.85 85.3979C105.413 85.3979 103.991 85.6808 102.664 86.2305C101.337 86.7801 100.131 87.5858 99.1156 88.6014C98.1 89.6171 97.2943 90.8228 96.7447 92.1498C96.195 93.4768 95.9121 94.8991 95.9121 96.3354C95.9121 97.7718 96.195 99.194 96.7447 100.521C97.2943 101.848 98.1 103.054 99.1156 104.069C100.131 105.085 101.337 105.891 102.664 106.44C103.991 106.99 105.413 107.273 106.85 107.273C109.75 107.273 112.532 106.121 114.584 104.069C116.635 102.018 117.787 99.2362 117.787 96.3354C117.787 93.4346 116.635 90.6526 114.584 88.6014C112.532 86.5503 109.75 85.3979 106.85 85.3979ZM124.641 108.888C123.629 107.742 122.141 107.013 120.489 107.013H116.512C115.785 107.013 115.064 107.156 114.393 107.434C113.721 107.713 113.11 108.121 112.596 108.635C112.082 109.15 111.674 109.76 111.396 110.432C111.117 111.104 110.974 111.825 110.975 112.552V126.465C110.975 127.933 111.558 129.342 112.597 130.38C113.635 131.419 115.043 132.002 116.512 132.002H120.487C122.141 132.002 123.627 131.273 124.639 130.127C124.897 129.814 125.023 129.414 124.991 129.01C124.959 128.606 124.771 128.23 124.467 127.962C124.164 127.694 123.767 127.554 123.363 127.572C122.958 127.591 122.576 127.766 122.298 128.06C122.071 128.318 121.792 128.524 121.48 128.665C121.167 128.806 120.828 128.878 120.485 128.877H116.512C115.179 128.877 114.1 127.796 114.1 126.465V112.552C114.1 111.219 115.179 110.138 116.512 110.138H120.487C121.208 110.138 121.852 110.452 122.298 110.956C122.574 111.259 122.958 111.441 123.368 111.463C123.777 111.485 124.179 111.346 124.486 111.074C124.794 110.803 124.982 110.421 125.011 110.012C125.039 109.603 124.906 109.199 124.639 108.888H124.641Z",
    fill: "#06323A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.569 118.402C130.862 118.695 131.026 119.092 131.026 119.506C131.026 119.92 130.862 120.317 130.569 120.61L126.402 124.777C126.108 125.062 125.713 125.22 125.304 125.216C124.894 125.213 124.502 125.049 124.212 124.759C123.922 124.47 123.758 124.078 123.754 123.668C123.75 123.258 123.908 122.864 124.192 122.569L128.359 118.402C128.652 118.109 129.049 117.945 129.463 117.945C129.877 117.945 130.276 118.109 130.569 118.402Z",
    fill: "#06323A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.569 120.613C130.862 120.32 131.026 119.922 131.026 119.508C131.026 119.094 130.862 118.697 130.569 118.404L126.402 114.238C126.108 113.953 125.713 113.795 125.304 113.798C124.894 113.802 124.502 113.966 124.212 114.255C123.922 114.545 123.758 114.937 123.754 115.347C123.75 115.756 123.908 116.151 124.192 116.446L128.359 120.613C128.652 120.905 129.049 121.069 129.463 121.069C129.877 121.069 130.276 120.905 130.569 120.613Z",
    fill: "#06323A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.441 119.508C116.441 119.094 116.606 118.697 116.899 118.403C117.192 118.11 117.59 117.946 118.004 117.946H128.421C128.835 117.946 129.232 118.11 129.525 118.403C129.818 118.697 129.983 119.094 129.983 119.508C129.983 119.923 129.818 120.32 129.525 120.613C129.232 120.906 128.835 121.071 128.421 121.071H118.004C117.59 121.071 117.192 120.906 116.899 120.613C116.606 120.32 116.441 119.923 116.441 119.508Z",
    fill: "#06323A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.883 111.804C107.862 112.052 107.852 112.3 107.852 112.552V126.465C107.852 128.019 108.26 129.475 108.977 130.735H89.9974C89.0305 130.735 88.1031 130.351 87.4194 129.668C86.7357 128.984 86.3516 128.057 86.3516 127.09V119.442C86.3516 118.165 87.0557 116.992 88.1849 116.392C94.2395 113.174 101.03 111.593 107.883 111.806V111.804Z",
    fill: "#06323A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_851_3241",
    x: -0.000782013,
    y: 0.0000114441,
    width: 216.4,
    height: 216.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.23 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_851_3241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_851_3241",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogouticon);
export default __webpack_public_path__ + "static/media/logouticon.78f7dc45dce8e91e09b1622ca1468809.svg";
export { ForwardRef as ReactComponent };